import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Checkbox, Grid, Typography } from '@material-ui/core';
import { filter, includes, lowerCase, map } from 'lodash';
import NavBar from '../../components/NavBarSearchSong';
import { CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import SvgList from '../../components/SvgList';
import Popup from '../../components/Popup';
import { artistActions } from '../../actions';
import Settings from '../../assets/Settings.png';
import searchIcon from '../../assets/ic_search.png';
import SearchBox from '../../components/SearchBox';
import { Button } from '../../components';

const AllArtists = () => {
  const history = useHistory();
  const [artists, setArtists] = useState([]);
  const [currentPage, setCurrentPage] = useState({ page: 1, isLast: false });
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [popUp, setPopup] = useState(false);
  const [isDeletingArtist, setIsDeletingArtist] = useState(false);
  const [shouldDetelteAllData, setShouldDetelteAllData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deletePopUp, setDeletePopUp] = useState({ isOpen: false, id: null });
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [isFetchingMore, setIsFetchingMore] = useState(false);

  const handleDeleteIconClick = (e, id) => {
    e.stopPropagation();
    setPopup(true);
    setSelectedItemId(id);
  };

  const handleDeteleArtist = async () => {
    setIsDeletingArtist(true);
    const isSucess = await artistActions.deleteArtist(selectedItemId, shouldDetelteAllData);
    console.log(isSucess, 'isSucess');
    if (isSucess) {
      const filteredArtist = filter(artists, (artist) => artist.id !== selectedItemId);
      setArtists(map(filteredArtist, (artist, index) => ({ ...artist, result: `#${index + 1}` })));
      setSelectedItemId(null);
      setShouldDetelteAllData(false);
    }
    setPopup(false);
    setIsDeletingArtist(false);
  };

  const filteredArtists = filter(artists, (artist) => {
    return (
      includes(lowerCase(artist.first_name), search.toLowerCase()) ||
      includes(lowerCase(artist.last_name), search.toLowerCase()) ||
      includes(lowerCase(artist.country), search.toLowerCase())
    );
  });

  const handleSearchInputChange = async (searchVal) => {
    setSearchInput(searchVal);
  };

  const fetchMoreArtists = async () => {
    if (isFetchingMore || currentPage.isLast) return;

    setIsFetchingMore(true);
    const artistsFromBE = await artistActions.fetchAllArtists({
      page: currentPage.page,
      limit: 50,
      search: searchInput,
    });
    setArtists((prev) => [...prev, ...artistsFromBE]);
    setIsFetchingMore(false);
    setCurrentPage((prev) => ({
      page: prev.page + 1,
      isLast: artistsFromBE.length < 50,
    }));
  };

  const handleScroll = (e) => {
    // detect when scrolled to bottom before reaching bottom by 20px
    const bottom = e.target.scrollHeight - e.target.scrollTop - 20 <= e.target.clientHeight;
    if (bottom && !currentPage.isLast) {
      fetchMoreArtists();
    }
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const artistsFromBE = await artistActions.fetchAllArtists({
        page: 1,
        limit: 50,
        search: searchInput,
      });
      setArtists(artistsFromBE);
      setIsLoading(false);
      setCurrentPage((prev) => ({
        page: prev.page + 1,
        isLast: artistsFromBE.length < 50,
      }));
    })();
  }, [searchInput]);

  return (
    <>
      <NavBar data="All Artist" icon={Settings} currentRouteName="All Artist" breadcrumbsPath={[{ name: 'Artist' }]} />
      <div className="content" style={{ marginTop: 73 }}>
        <div style={{ marginBottom: '12px' }}>
          <Grid container style={{ justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <SearchBox placeholder="Search User here..." onChange={(e) => handleSearchInputChange(e)} />
            </div>
          </Grid>
        </div>

        <div style={{ display: 'flex', height: '100%', overflow: 'hidden', flex: 1, width: '100%' }}>
          <TableContainer className="tbl_wraper tbl_wrap" component={Paper} onScroll={handleScroll}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell className="table_font result">Result</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Country</TableCell>
                  <TableCell>Total Songs</TableCell>
                  <TableCell>Total Revenue</TableCell>
                  <TableCell className="action">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && (
                  <div className="table_initial_loader">
                    <CircularProgress />
                  </div>
                )}
                {artists?.length === 0 && !isLoading ? (
                  <div className="table_initial_loader">
                    <h4
                      style={{
                        textAlign: 'center',
                        marginBottom: 20,
                        fontSize: 20,
                        lineHeight: '32px',
                        maxWidth: '60%',
                        marginInline: 'auto',
                      }}
                    >
                      No Songs Found
                    </h4>
                  </div>
                ) : (
                  artists?.map((row, index) => (
                    <TableRow key={row.id} style={{ cursor: 'pointer' }} onClick={() => history.push(`/artists/${row.id}`)}>
                      <TableCell className="result">#{++index}</TableCell>
                      <TableCell>{row.first_name}</TableCell>
                      <TableCell>{row.country}</TableCell>
                      <TableCell>{row.total_songs}</TableCell>
                      <TableCell>{parseFloat(row.total_revenue.toFixed(2))}</TableCell>
                      <TableCell className="action">
                        <div
                          style={{ display: 'flex', columnGap: 15, cursor: 'pointer' }}
                          onClick={(e) => handleDeleteIconClick(e, row.id)}
                        >
                          <SvgList name="cancel-icon" />
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}

                {isFetchingMore && (
                  <TableRow className="fetch_more_loader">
                    <CircularProgress />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>

      <Popup open={popUp} onClose={() => !isDeletingArtist && setPopup(false)}>
        <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
          Delete Artist
        </h4>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
          <Checkbox color="primary" checked={shouldDetelteAllData} onChange={(e) => setShouldDetelteAllData(e.target.checked)} />
          <Typography variant="body1">Delete all data related to the artist</Typography>
        </div>
        <div className="button-group" style={{ '--button-color': '#6900af' }}>
          <Button onClick={() => !isDeletingArtist && setPopup(false)} className="button transparent">
            Cancel
          </Button>
          <Button onClick={handleDeteleArtist} isLoading={isDeletingArtist} className="button primary">
            Confirm
          </Button>
        </div>
      </Popup>
    </>
  );
};

export default AllArtists;

